import { SocketEventType } from "@swivl-mono/types";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { UserDetailsCardVariant } from "../../../Components/UserDetailsCard/UserDetailsCard";
import { GetChannelFromParam } from "../../../Helpers/Conversations/Conversations.Helper";
// import useSessionMessageData from "../../Hooks/useSessionMessageData";
import { useUrlState } from "../../../Hooks/useUrlState";
import { Member } from "../../../Models/Member/Member.Current";
import MembersModel from "../../../Models/Member/Members.Model";
import ModalModel from "../../../Models/Modal/Modal.Model";
import SocketEventsManager from "../../../Models/SocketEvents/SocketEvents.Manager";
import { UsersModel } from "../../../Models/Users/Users.Model";
import { UsersOnlineManager } from "../../../Models/Users/UsersOnline.Manager";
import UserVarsModel from "../../../Models/Variables/UserVars.Model";
import { StartShiftModal } from "./Components/StartShiftModal/StartShiftModal";
import UserDetails, { UserDetailsTabID } from "./DetailsColumn/UserDetails";
import { MultiChannelColumn } from "./MultiChannelColumn/MultiChannelColumn";
import { ConversationUserListColumn } from "./UserListColumn/Conversations.UserListColumn";

export type EscalationStatus = "open" | "closed";

export enum ConversationUserListTabsStateType {
  Loading,
  Open,
  Closed
}

function ConversationsView() {
  const { users, conversations } = UsersModel.useState();
  const { isAvailable } = MembersModel.useState();
  const { userId } = useParams();
  const navigate = useNavigate();
  const selectedUserId = userId ? Number(userId) : undefined;
  const selectedUser = users ? users[selectedUserId || -1] : undefined;
  const { vars } = UserVarsModel.useState((s) => s);
  const { getSearchParam, setSearchParam } = useUrlState();
  const channel = GetChannelFromParam(getSearchParam("channel"));

  // const selectedConversation = useMemo(() => {
  //   if (!conversations || !selectedUserId) return undefined;
  //   return conversations[selectedUserId];
  // }, [conversations, selectedUserId]);

  useEffect(() => {
    if (selectedUserId) {
      console.log("PUF loadForUser :", selectedUserId);
      UsersModel.loadForUser(selectedUserId!);
    }
  }, [selectedUserId]);

  const selectedConversation = !conversations || !selectedUserId ? undefined : conversations[selectedUserId];
  console.log("RUF selectedConversation:", selectedConversation);
  let session;
  if (selectedConversation && selectedConversation.sessions?.[channel]) {
    session = selectedConversation.sessions[channel];
  }

  const [tabState, setTabState] = useState<ConversationUserListTabsStateType>(
    selectedUserId ? ConversationUserListTabsStateType.Loading : ConversationUserListTabsStateType.Open
  );
  // const sessionDataInitialSessions = useMemo(() => {
  //   if (!sessions) return {};
  //   return Object.values(sessions).reduce((acc, session) => {
  //     if (session?.escalation && Object.values(session.escalation).length > 0) {
  //       acc[session.id] = session;
  //     }
  //     return acc;
  //   }, {} as { [sessionId: number]: SessionInterface });
  // }, [sessions]);

  // const { sessionMessageData, markSessionAsRead } = useSessionMessageData(sessionDataInitialSessions, session?.id);

  useEffect(() => {
    UsersModel.loadAll();
    const reloadInterval = setInterval(
      () => {
        UsersModel.loadAll();
      },
      1000 * 60 * 3
    ); // Reload every 3 minutes
    if (!Member.hasSeenStartShiftModal && !isAvailable) {
      ModalModel.showModalWithContent(null, <StartShiftModal />, 544, 544, false);
    }
    UsersOnlineManager.start(); // Start the online manager when entering the view
    return () => {
      clearInterval(reloadInterval);
      UsersOnlineManager.stop(); // Stop the online manager when leaving the view
    };
  }, []);

  const userVars = useMemo(() => (selectedUserId && vars ? vars[selectedUserId] : undefined), [vars, selectedUserId]);

  // set load user, vars, and events for selected user
  useEffect(() => {
    if (selectedUserId) {
      // NotesModel.loadForUser(selectedUserId);
      UserVarsModel.loadForUser(selectedUserId);
      UsersModel.loadUsersByIds([selectedUserId]);
    }
    // NotificationsManager.registerForConversationUpdates(selectedUserId);
    if (selectedUserId) {
      SocketEventsManager.setSubscriptionState(
        [
          SocketEventType.SESSION,
          SocketEventType.ESCALATION,
          SocketEventType.VARS,
          SocketEventType.USERS_ONLINE,
          SocketEventType.NOTIFICATION,
          SocketEventType.TICKET
        ],
        selectedUserId
      );
    } else {
      SocketEventsManager.setSubscriptionState([
        SocketEventType.SESSION,
        SocketEventType.ESCALATION,
        SocketEventType.USERS_ONLINE,
        SocketEventType.NOTIFICATION,
        SocketEventType.TICKET
      ]);
    }
    return () => {
      // Reset to global defaults (NOTIFICATION + TICKET + AVAILABLE_MEMBERS)
      SocketEventsManager.setSubscriptionState([SocketEventType.NOTIFICATION, SocketEventType.TICKET, SocketEventType.AVAILABLE_MEMBERS]);
    };
  }, [selectedUserId]);

  // default to most recent channel on initial navigation to conversation
  useEffect(() => {
    if (conversations && selectedUserId && conversations[selectedUserId]) {
      const mostRecentChannel = conversations[selectedUserId].lastUserMessageChannel;

      if (mostRecentChannel) {
        setSearchParam("channel", mostRecentChannel);
      }
    }
  }, [selectedUserId]);

  const setTab = (state: ConversationUserListTabsStateType, fromClick?: boolean) => {
    setTabState(state);
    if (fromClick) {
      navigate("/contact-center/conversations"); // We need to reset the URL to conversation so we can switch tabs.
    }
  };

  // const handleMarkSessionAsRead = (sessionId: number, userId: number) => {
  //   markSessionAsRead(sessionId, userId);
  // };

  return (
    <div className="flex size-full divide-x divide-grey-200 overflow-hidden bg-white">
      <div className="h-full w-1/3">
        <ConversationUserListColumn
          setTab={setTab}
          tabState={tabState}
          conversations={conversations}
          selectedUserId={selectedUserId}
          // sessionMessageData={sessionMessageData}
          users={users}
        />
      </div>
      <div className="h-full w-1/3">
        <MultiChannelColumn
          tabState={tabState}
          conversation={selectedConversation}
          selectedUser={selectedUser}
          // handleMarkSessionAsRead={handleMarkSessionAsRead}
          channel={channel}
          session={session}
          // sessionMessageData={sessionMessageData}
        />
      </div>
      <div className="h-full w-1/3">
        {selectedUser && userVars && (
          <UserDetails
            user={selectedUser}
            userVars={userVars}
            userCardVariant={UserDetailsCardVariant.DETAILED}
            tabs={[
              { id: UserDetailsTabID.Details, label: "Customer Details", badge: false },
              { id: UserDetailsTabID.Inventory, label: "Inventory", badge: false },
              { id: UserDetailsTabID.Notes, label: "Notes", badge: false },
              { id: UserDetailsTabID.Recordings, label: "Recordings", badge: false }
            ]}
          />
        )}
      </div>
    </div>
  );
}

export default ConversationsView;
